import { paths } from "#webapp/src/constants/site.constant";
import { Button, Link } from "@clockwise/design-system";
import { Close } from "@clockwise/design-system/icons";
import React from "react";

export const AuthPermissionInfoCard = ({ onClose }: { onClose: () => void }) => {
  return (
    <div className="cw-relative cw-bg-default cw-rounded cw-border cw-border-solid cw-border-default">
      <div className="cw-flex cw-flex-nowrap cw-items-start cw-mx-5 cw-my-3">
        <div className="cw-heading-sm">
          Why do we need permission to access your Google account?
        </div>
        <div className="cw-justify-self-end cw-px-2">
          <Button variant="text" size="mini" rounded startIcon={Close} onClick={onClose} />
        </div>
      </div>

      <div className="cw-body-base cw-mx-5 cw-my-3 cw-space-y-3">
        <div>
          Clockwise requests the minimum permissions needed to be able to deliver a rich calendar
          experience, for example:
        </div>
        <ul className="cw-space-y-2 cw-list-disc cw-px-4">
          <li>View your calendar events</li>
          <li>See conference room availability</li>
          <li>Make sure that the meeting times we suggest work for all meeting attendees</li>
        </ul>

        <div>
          Learn more by visiting our{" "}
          <Link href={paths.security} target="_blank">
            security page
          </Link>
          .
        </div>
      </div>
    </div>
  );
};
